import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    components: {
    },
})

export default class DemostradorWeb extends Vue {

    public created() {
        document.documentElement.scrollTop;
    }

    public get language() {
        return this.$root.$i18n.locale.toString();
    }

    public goTo(route: string) {
        this.$router.push({ name: route });
    }
}